import React, { useState } from "react";
import { Input } from "antd";
import Scrollbars from "react-custom-scrollbars";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";

const MenuCategoryPanel = ({
  bestsellerCategories,
  productCategoriesList,
  selectedCategory,
  loading,
  handleCategoryClick,
}) => {
  const [categorySearch, setCategorySearch] = useState("");
  const { isMobile } = useWindowDimensions();

  const categories = (bestsellerCategories.length > 0 ? bestsellerCategories : productCategoriesList)
    .filter((categorie) => categorie.name.toLowerCase().includes(categorySearch.toLowerCase()))
    .sort((a, b) => a.name.localeCompare(b.name));

  if (isMobile) {
    return (
      <div className="menu-category-panel-mobile">
        <Input
          placeholder="Search by categories"
          value={categorySearch}
          onChange={(e) => setCategorySearch(e.target.value)}
          className="menu-category-search-mobile"
        />
        <div className="menu-category-chips">
          {categories.map((categorie) => {
            const isSelected = selectedCategory === categorie.mProductCategoryId;
            return (
              <button
                key={categorie.mProductCategoryId}
                type="button"
                className={`menu-category-chip ${isSelected ? "selected" : ""}`}
                disabled={loading}
                onClick={() => handleCategoryClick(categorie.mProductCategoryId, categorie.name)}
              >
                {categorie.name}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "18%",
        background: "#fff",
        borderRight: "1px solid #eee",
        padding: "1vh 0.5vw",
        height: "87vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Search bar for categories */}
      <Input
        placeholder="Search by categories"
        value={categorySearch}
        onChange={(e) => setCategorySearch(e.target.value)}
        style={{ marginBottom: "1vh", borderRadius: "6px" }}
      />

      {/* Category list */}
      <Scrollbars autoHide style={{ flex: 1 }}>
        {categories.map((categorie) => {
          const isSelected = selectedCategory === categorie.mProductCategoryId;
          return (
            <div
              key={categorie.mProductCategoryId}
              onClick={() => handleCategoryClick(categorie.mProductCategoryId, categorie.name)}
              style={{
                padding: "6px 10px",
                cursor: loading ? "not-allowed" : "pointer",
                background: isSelected ? "#F5F6FA" : "transparent",
                color: isSelected ? "#000" : "#555",
                fontWeight: isSelected ? "600" : "400",
                borderLeft: isSelected ? "4px solid #2F3856" : "4px solid transparent",
              }}
            >
              {categorie.name}
            </div>
          );
        })}
      </Scrollbars>
    </div>
  );
};

export default React.memo(MenuCategoryPanel);
